
function getHistory(data) {
	return {
		url: `/morty/assistant/request/history/${data.key}?cursor=${data.cursor || ''}`,
		method: 'GET',
		cache: {
			minutes: 5
		}
	};
}

export { getHistory };
